import { useContext } from 'react';
import { createContext } from 'react';

import { TabContentProps } from '../@types/TabContentProps';

export const TabContentContext = createContext<TabContentProps>({} as TabContentProps);

TabContentContext.displayName = 'TabContent';

const TabContentProvider = (props: TabContentProps) => (
	<TabContentContext.Provider value={props}>{props.children}</TabContentContext.Provider>
);

export const useTabContent = () => {
	const context = useContext(TabContentContext);

	return context;
};

export default TabContentProvider;
